/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as OnboardingRouteImport } from './routes/_onboarding'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppDesignSystemRouteImport } from './routes/_app/design-system'
import { Route as AppEmailsRouteImport } from './routes/_app/emails'
import { Route as AppPipelineRouteImport } from './routes/_app/pipeline'
import { Route as AppUsersRouteImport } from './routes/_app/users'
import { Route as AppUtmCampaignsRouteImport } from './routes/_app/utm-campaigns'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthSetPasswordRouteImport } from './routes/_auth/set-password'
import { Route as AuthTwoFactorRouteImport } from './routes/_auth/two-factor'
import { Route as EnquireIndexRouteImport } from './routes/enquire/index'
import { Route as EnquireThanksRouteImport } from './routes/enquire/thanks'
import { Route as AppAccountIndexRouteImport } from './routes/_app/account/index'
import { Route as AppAccountNotificationsRouteImport } from './routes/_app/account/notifications'
import { Route as AppAccountSecurityRouteImport } from './routes/_app/account/security'
import { Route as AppDocumentsProductOverviewRouteImport } from './routes/_app/documents/product-overview'
import { Route as AppDocumentsUserManualRouteImport } from './routes/_app/documents/user-manual'
import { Route as AppLeadsIndexRouteImport } from './routes/_app/leads/index'
import { Route as AppLeadsLeadIdRouteImport } from './routes/_app/leads/$leadId'
import { Route as AppSettingsAuditLogRouteImport } from './routes/_app/settings/audit-log'
import { Route as AppSettingsLeadFormRouteImport } from './routes/_app/settings/lead-form'
import { Route as AppSettingsServicesRouteImport } from './routes/_app/settings/services'
import { Route as AppSettingsStagesRouteImport } from './routes/_app/settings/stages'
import { Route as OnboardingOnboardingSecurityRouteImport } from './routes/_onboarding/onboarding/security'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/_onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppDesignSystemRoute = AppDesignSystemRouteImport.update({
  id: '/design-system',
  path: '/design-system',
  getParentRoute: () => AppRoute,
} as any)
const AppEmailsRoute = AppEmailsRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => AppRoute,
} as any)
const AppPipelineRoute = AppPipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppUtmCampaignsRoute = AppUtmCampaignsRouteImport.update({
  id: '/utm-campaigns',
  path: '/utm-campaigns',
  getParentRoute: () => AppRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSetPasswordRoute = AuthSetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTwoFactorRoute = AuthTwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => AuthRoute,
} as any)
const EnquireIndexRoute = EnquireIndexRouteImport.update({
  id: '/enquire/',
  path: '/enquire/',
  getParentRoute: () => rootRouteImport,
} as any)
const EnquireThanksRoute = EnquireThanksRouteImport.update({
  id: '/enquire/thanks',
  path: '/enquire/thanks',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountNotificationsRoute = AppAccountNotificationsRouteImport.update({
  id: '/account/notifications',
  path: '/account/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountSecurityRoute = AppAccountSecurityRouteImport.update({
  id: '/account/security',
  path: '/account/security',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsProductOverviewRoute =
  AppDocumentsProductOverviewRouteImport.update({
    id: '/documents/product-overview',
    path: '/documents/product-overview',
    getParentRoute: () => AppRoute,
  } as any)
const AppDocumentsUserManualRoute = AppDocumentsUserManualRouteImport.update({
  id: '/documents/user-manual',
  path: '/documents/user-manual',
  getParentRoute: () => AppRoute,
} as any)
const AppLeadsIndexRoute = AppLeadsIndexRouteImport.update({
  id: '/leads/',
  path: '/leads/',
  getParentRoute: () => AppRoute,
} as any)
const AppLeadsLeadIdRoute = AppLeadsLeadIdRouteImport.update({
  id: '/leads/$leadId',
  path: '/leads/$leadId',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsAuditLogRoute = AppSettingsAuditLogRouteImport.update({
  id: '/settings/audit-log',
  path: '/settings/audit-log',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsLeadFormRoute = AppSettingsLeadFormRouteImport.update({
  id: '/settings/lead-form',
  path: '/settings/lead-form',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsServicesRoute = AppSettingsServicesRouteImport.update({
  id: '/settings/services',
  path: '/settings/services',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsStagesRoute = AppSettingsStagesRouteImport.update({
  id: '/settings/stages',
  path: '/settings/stages',
  getParentRoute: () => AppRoute,
} as any)
const OnboardingOnboardingSecurityRoute =
  OnboardingOnboardingSecurityRouteImport.update({
    id: '/onboarding/security',
    path: '/onboarding/security',
    getParentRoute: () => OnboardingRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/dashboard': typeof AppDashboardRoute
  '/design-system': typeof AppDesignSystemRoute
  '/emails': typeof AppEmailsRoute
  '/pipeline': typeof AppPipelineRoute
  '/users': typeof AppUsersRoute
  '/utm-campaigns': typeof AppUtmCampaignsRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/set-password': typeof AuthSetPasswordRoute
  '/two-factor': typeof AuthTwoFactorRoute
  '/enquire/thanks': typeof EnquireThanksRoute
  '/enquire/': typeof EnquireIndexRoute
  '/account/notifications': typeof AppAccountNotificationsRoute
  '/account/security': typeof AppAccountSecurityRoute
  '/documents/product-overview': typeof AppDocumentsProductOverviewRoute
  '/documents/user-manual': typeof AppDocumentsUserManualRoute
  '/leads/$leadId': typeof AppLeadsLeadIdRoute
  '/settings/audit-log': typeof AppSettingsAuditLogRoute
  '/settings/lead-form': typeof AppSettingsLeadFormRoute
  '/settings/services': typeof AppSettingsServicesRoute
  '/settings/stages': typeof AppSettingsStagesRoute
  '/onboarding/security': typeof OnboardingOnboardingSecurityRoute
  '/account/': typeof AppAccountIndexRoute
  '/leads/': typeof AppLeadsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/dashboard': typeof AppDashboardRoute
  '/design-system': typeof AppDesignSystemRoute
  '/emails': typeof AppEmailsRoute
  '/pipeline': typeof AppPipelineRoute
  '/users': typeof AppUsersRoute
  '/utm-campaigns': typeof AppUtmCampaignsRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/set-password': typeof AuthSetPasswordRoute
  '/two-factor': typeof AuthTwoFactorRoute
  '/enquire/thanks': typeof EnquireThanksRoute
  '/enquire': typeof EnquireIndexRoute
  '/account/notifications': typeof AppAccountNotificationsRoute
  '/account/security': typeof AppAccountSecurityRoute
  '/documents/product-overview': typeof AppDocumentsProductOverviewRoute
  '/documents/user-manual': typeof AppDocumentsUserManualRoute
  '/leads/$leadId': typeof AppLeadsLeadIdRoute
  '/settings/audit-log': typeof AppSettingsAuditLogRoute
  '/settings/lead-form': typeof AppSettingsLeadFormRoute
  '/settings/services': typeof AppSettingsServicesRoute
  '/settings/stages': typeof AppSettingsStagesRoute
  '/onboarding/security': typeof OnboardingOnboardingSecurityRoute
  '/account': typeof AppAccountIndexRoute
  '/leads': typeof AppLeadsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_onboarding': typeof OnboardingRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/design-system': typeof AppDesignSystemRoute
  '/_app/emails': typeof AppEmailsRoute
  '/_app/pipeline': typeof AppPipelineRoute
  '/_app/users': typeof AppUsersRoute
  '/_app/utm-campaigns': typeof AppUtmCampaignsRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/set-password': typeof AuthSetPasswordRoute
  '/_auth/two-factor': typeof AuthTwoFactorRoute
  '/enquire/thanks': typeof EnquireThanksRoute
  '/enquire/': typeof EnquireIndexRoute
  '/_app/account/notifications': typeof AppAccountNotificationsRoute
  '/_app/account/security': typeof AppAccountSecurityRoute
  '/_app/documents/product-overview': typeof AppDocumentsProductOverviewRoute
  '/_app/documents/user-manual': typeof AppDocumentsUserManualRoute
  '/_app/leads/$leadId': typeof AppLeadsLeadIdRoute
  '/_app/settings/audit-log': typeof AppSettingsAuditLogRoute
  '/_app/settings/lead-form': typeof AppSettingsLeadFormRoute
  '/_app/settings/services': typeof AppSettingsServicesRoute
  '/_app/settings/stages': typeof AppSettingsStagesRoute
  '/_onboarding/onboarding/security': typeof OnboardingOnboardingSecurityRoute
  '/_app/account/': typeof AppAccountIndexRoute
  '/_app/leads/': typeof AppLeadsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/privacy'
    | '/dashboard'
    | '/design-system'
    | '/emails'
    | '/pipeline'
    | '/users'
    | '/utm-campaigns'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/set-password'
    | '/two-factor'
    | '/enquire/thanks'
    | '/enquire/'
    | '/account/notifications'
    | '/account/security'
    | '/documents/product-overview'
    | '/documents/user-manual'
    | '/leads/$leadId'
    | '/settings/audit-log'
    | '/settings/lead-form'
    | '/settings/services'
    | '/settings/stages'
    | '/onboarding/security'
    | '/account/'
    | '/leads/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/privacy'
    | '/dashboard'
    | '/design-system'
    | '/emails'
    | '/pipeline'
    | '/users'
    | '/utm-campaigns'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/set-password'
    | '/two-factor'
    | '/enquire/thanks'
    | '/enquire'
    | '/account/notifications'
    | '/account/security'
    | '/documents/product-overview'
    | '/documents/user-manual'
    | '/leads/$leadId'
    | '/settings/audit-log'
    | '/settings/lead-form'
    | '/settings/services'
    | '/settings/stages'
    | '/onboarding/security'
    | '/account'
    | '/leads'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/_onboarding'
    | '/privacy'
    | '/_app/dashboard'
    | '/_app/design-system'
    | '/_app/emails'
    | '/_app/pipeline'
    | '/_app/users'
    | '/_app/utm-campaigns'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_auth/set-password'
    | '/_auth/two-factor'
    | '/enquire/thanks'
    | '/enquire/'
    | '/_app/account/notifications'
    | '/_app/account/security'
    | '/_app/documents/product-overview'
    | '/_app/documents/user-manual'
    | '/_app/leads/$leadId'
    | '/_app/settings/audit-log'
    | '/_app/settings/lead-form'
    | '/_app/settings/services'
    | '/_app/settings/stages'
    | '/_onboarding/onboarding/security'
    | '/_app/account/'
    | '/_app/leads/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  OnboardingRoute: typeof OnboardingRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  EnquireThanksRoute: typeof EnquireThanksRoute
  EnquireIndexRoute: typeof EnquireIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_onboarding': {
      id: '/_onboarding'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/design-system': {
      id: '/_app/design-system'
      path: '/design-system'
      fullPath: '/design-system'
      preLoaderRoute: typeof AppDesignSystemRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/emails': {
      id: '/_app/emails'
      path: '/emails'
      fullPath: '/emails'
      preLoaderRoute: typeof AppEmailsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pipeline': {
      id: '/_app/pipeline'
      path: '/pipeline'
      fullPath: '/pipeline'
      preLoaderRoute: typeof AppPipelineRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/utm-campaigns': {
      id: '/_app/utm-campaigns'
      path: '/utm-campaigns'
      fullPath: '/utm-campaigns'
      preLoaderRoute: typeof AppUtmCampaignsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/set-password': {
      id: '/_auth/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof AuthSetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/two-factor': {
      id: '/_auth/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof AuthTwoFactorRouteImport
      parentRoute: typeof AuthRoute
    }
    '/enquire/': {
      id: '/enquire/'
      path: '/enquire'
      fullPath: '/enquire/'
      preLoaderRoute: typeof EnquireIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/enquire/thanks': {
      id: '/enquire/thanks'
      path: '/enquire/thanks'
      fullPath: '/enquire/thanks'
      preLoaderRoute: typeof EnquireThanksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/account/': {
      id: '/_app/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof AppAccountIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account/notifications': {
      id: '/_app/account/notifications'
      path: '/account/notifications'
      fullPath: '/account/notifications'
      preLoaderRoute: typeof AppAccountNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account/security': {
      id: '/_app/account/security'
      path: '/account/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof AppAccountSecurityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/product-overview': {
      id: '/_app/documents/product-overview'
      path: '/documents/product-overview'
      fullPath: '/documents/product-overview'
      preLoaderRoute: typeof AppDocumentsProductOverviewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/user-manual': {
      id: '/_app/documents/user-manual'
      path: '/documents/user-manual'
      fullPath: '/documents/user-manual'
      preLoaderRoute: typeof AppDocumentsUserManualRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads/': {
      id: '/_app/leads/'
      path: '/leads'
      fullPath: '/leads/'
      preLoaderRoute: typeof AppLeadsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads/$leadId': {
      id: '/_app/leads/$leadId'
      path: '/leads/$leadId'
      fullPath: '/leads/$leadId'
      preLoaderRoute: typeof AppLeadsLeadIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/audit-log': {
      id: '/_app/settings/audit-log'
      path: '/settings/audit-log'
      fullPath: '/settings/audit-log'
      preLoaderRoute: typeof AppSettingsAuditLogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/lead-form': {
      id: '/_app/settings/lead-form'
      path: '/settings/lead-form'
      fullPath: '/settings/lead-form'
      preLoaderRoute: typeof AppSettingsLeadFormRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/services': {
      id: '/_app/settings/services'
      path: '/settings/services'
      fullPath: '/settings/services'
      preLoaderRoute: typeof AppSettingsServicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/stages': {
      id: '/_app/settings/stages'
      path: '/settings/stages'
      fullPath: '/settings/stages'
      preLoaderRoute: typeof AppSettingsStagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_onboarding/onboarding/security': {
      id: '/_onboarding/onboarding/security'
      path: '/onboarding/security'
      fullPath: '/onboarding/security'
      preLoaderRoute: typeof OnboardingOnboardingSecurityRouteImport
      parentRoute: typeof OnboardingRoute
    }
  }
}

interface AppRouteChildren {
  AppDashboardRoute: typeof AppDashboardRoute
  AppDesignSystemRoute: typeof AppDesignSystemRoute
  AppEmailsRoute: typeof AppEmailsRoute
  AppPipelineRoute: typeof AppPipelineRoute
  AppUsersRoute: typeof AppUsersRoute
  AppUtmCampaignsRoute: typeof AppUtmCampaignsRoute
  AppAccountNotificationsRoute: typeof AppAccountNotificationsRoute
  AppAccountSecurityRoute: typeof AppAccountSecurityRoute
  AppDocumentsProductOverviewRoute: typeof AppDocumentsProductOverviewRoute
  AppDocumentsUserManualRoute: typeof AppDocumentsUserManualRoute
  AppLeadsLeadIdRoute: typeof AppLeadsLeadIdRoute
  AppSettingsAuditLogRoute: typeof AppSettingsAuditLogRoute
  AppSettingsLeadFormRoute: typeof AppSettingsLeadFormRoute
  AppSettingsServicesRoute: typeof AppSettingsServicesRoute
  AppSettingsStagesRoute: typeof AppSettingsStagesRoute
  AppAccountIndexRoute: typeof AppAccountIndexRoute
  AppLeadsIndexRoute: typeof AppLeadsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDashboardRoute: AppDashboardRoute,
  AppDesignSystemRoute: AppDesignSystemRoute,
  AppEmailsRoute: AppEmailsRoute,
  AppPipelineRoute: AppPipelineRoute,
  AppUsersRoute: AppUsersRoute,
  AppUtmCampaignsRoute: AppUtmCampaignsRoute,
  AppAccountNotificationsRoute: AppAccountNotificationsRoute,
  AppAccountSecurityRoute: AppAccountSecurityRoute,
  AppDocumentsProductOverviewRoute: AppDocumentsProductOverviewRoute,
  AppDocumentsUserManualRoute: AppDocumentsUserManualRoute,
  AppLeadsLeadIdRoute: AppLeadsLeadIdRoute,
  AppSettingsAuditLogRoute: AppSettingsAuditLogRoute,
  AppSettingsLeadFormRoute: AppSettingsLeadFormRoute,
  AppSettingsServicesRoute: AppSettingsServicesRoute,
  AppSettingsStagesRoute: AppSettingsStagesRoute,
  AppAccountIndexRoute: AppAccountIndexRoute,
  AppLeadsIndexRoute: AppLeadsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSetPasswordRoute: typeof AuthSetPasswordRoute
  AuthTwoFactorRoute: typeof AuthTwoFactorRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSetPasswordRoute: AuthSetPasswordRoute,
  AuthTwoFactorRoute: AuthTwoFactorRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface OnboardingRouteChildren {
  OnboardingOnboardingSecurityRoute: typeof OnboardingOnboardingSecurityRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingOnboardingSecurityRoute: OnboardingOnboardingSecurityRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  OnboardingRoute: OnboardingRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  EnquireThanksRoute: EnquireThanksRoute,
  EnquireIndexRoute: EnquireIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
